import React from 'react';
import { useCursor } from '../contexts/CursorContext';
import CustomCursor from './CustomCursor';

/**
 * Wrapper component that connects CustomCursor to the CursorContext
 */
function CustomCursorWrapper() {
  const { cursorType, trailEnabled } = useCursor();

  return (
    <CustomCursor
      cursorType={cursorType}
      trailEnabled={trailEnabled}
    />
  );
}

export default CustomCursorWrapper;
